// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--XLLN-";
export var pageLink = "styles-module--pageLink--65nLQ";
export var smallerText = "styles-module--smallerText--J2Zyo";